import styled from 'styled-components'

type Props = {
  title: React.ReactNode
  active?: boolean
  onClick?: () => void
  disabled?: boolean
}

export const ControlsQuickOption: React.FC<Props> = ({
  title,
  onClick,
  active = false,
  disabled = false,
}) => (
  <Root type="button" $active={active} onClick={onClick} disabled={disabled}>
    <span>{title}</span>
  </Root>
)

const Root = styled.button<{ $active: boolean }>`
  background: ${({ $active }) =>
    $active ? 'var(--background-3)' : 'transparent'};
  border: 1px solid
    ${({ $active }) =>
      $active
        ? 'var(--background-9)'
        : 'var(--quick-option-inactive-border, var(--background-5))'};
  color: var(--text-11);

  border-radius: 10px;
  height: 32px;
  display: grid;
  justify-content: center;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  gap: 4px;
  padding-inline: 8px;
  transition: all 0.15s linear;

  font-size: 10px;
  font-weight: 600;

  cursor: pointer;
  line-height: normal;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`
